import React from 'react';
import { FormattedCurrency } from './formatted-currency.react-component';
/** React props interface for `DynamicCurrency` component. */

/**
 * ### DynamicCurrency
 *
 * Returns a span with formatted text via `currencyformatter.js`.
 */
export const DynamicCurrency = _ref => {
  let {
    value
  } = _ref;
  return typeof value === 'string' ? /*#__PURE__*/React.createElement("span", null, value) : /*#__PURE__*/React.createElement(FormattedCurrency, {
    value: value
  });
};
//# sourceMappingURL=dynamic-currency.react-component.js.map